import Vue from 'vue'
import Element from 'element-ui' // 引入element
import 'element-ui/lib/theme-chalk/index.css' // 引入element css
import PuzzleVerification from 'vue-puzzle-verification' // 引入图片验证器
import Viewer from 'v-viewer' // 引入图片查看器
import 'viewerjs/dist/viewer.css'
import './assets/icon/iconfont/iconfont.css' // 引入字体图标
import mycommon from './assets/js/myCommon.js' // 引入公共js方法
import './assets/js/preventReClick.js' // 引入按钮防止多次重复恶意点击
import myApi from './api/index.js' // 引入API接口
// import uploadApi from './api/upload.js' // 引入上传文件API接口
// import urlApi from './api/url.js' // 引入外网API接口
import webIM from './assets/js/im.js' // 引入腾讯IM
import App from './App.vue' // 引入 App主页面
import router from './router' // 引入路由
import store from './store' // 引入 vuex
import { vueBaberrage } from 'vue-baberrage' // 引入弹幕
import VideoPlayer from 'vue-video-player' // 引入直播插件
import 'videojs-flash' // 引入直播插件的格式解析
require('video.js/dist/video-js.css') // 引入直播插件相关
require('vue-video-player/src/custom-theme.css') // 引入直播插件相关

Vue.use(PuzzleVerification)

const hls = require('videojs-contrib-hls')

Vue.use(hls)

Vue.use(vueBaberrage)

Vue.use(VideoPlayer)

Vue.use(Element)

Vue.use(Viewer)

Vue.prototype.mycommon = mycommon // 继承公共js方法

Vue.prototype.myApi = myApi // 集成API接口
// Vue.prototype.uploadApi = uploadApi // 集成上传文件API接口
// Vue.prototype.urlApi = urlApi // 集成外网API接口

Vue.prototype.webIM = webIM // 继承webIM方法

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
